<template>
  <div class="route">
    <div class="route-bus" v-for="(route, rkey) in routes" :key="route.raceNum">
      <div class="route-station" v-for="(station, key) in route.route" :key="station.stCode">
        <div class="octobus__columns is-vcentered" v-if="getLabel(key, route.route.length, rkey, routes.length) === false">
          <div class="octobus__column is-one-third">
            <p class="station__change__label">{{$t('ticket.routeChange')}}</p>
          </div>
          <div class="octobus__column is-two-thirds">
            <div class="octobus__columns is-vcentered">
              <div class="octobus__column is-narrow">
                <font-awesome-icon :icon="iconBus" class="station-bus" />
                <font-awesome-icon :icon="iconArrow" class="station-arrow" />
                <font-awesome-icon :icon="iconBus" class="station-bus" />
              </div>
              <div class="station__change octobus__column">
                <p class="station__change__time">
                  <span>{{$t('ticket.routeChangeTime')}}</span>
                  <span class="has-text-weight-semibold is-size-6">{{`${route.changehours}:${route.changeminutes}`}}</span>
                </p>
                <p class="station__change__name">{{station.stArrName}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="octobus__columns" v-if="!key">
          <div class="octobus__column is-offset-2-desktop">{{$t('ticket.routeRaceName', {raceName: route.raceName})}}</div>
        </div>
        <div class="octobus__columns is-vcentered">
          <div class="octobus__column is-one-third" :class="{'is-paddingless': !getLabel(key, route.route.length, rkey, routes.length)}">
            <Label
              :label="getLabel(key, route.route.length, rkey, routes.length)"
            />
          </div>
          <div class="octobus__column is-two-thirds station-block">
            <p class="station has-text-weight-semibold is-size-6">{{getTime(station, key, route.route)}}</p>
            <p class="station-name" :class="{last: (key + 1) === route.route.length}">
              {{station.stArrName}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faBus, faAngleDoubleRight } from '@fortawesome/fontawesome-free-solid';
import Label from './Label';

export default {
  name: 'Route',
  components: {
    Label,
    FontAwesomeIcon,
  },
  props: {
    routes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getTime(route, index, all = []) {
      const isLastRoute = all.length === (index + 1);

      if (isLastRoute) {
        return route.timeArr;
      }

      if (route.timeDep !== '-') {
        return route.timeDep;
      }

      return route.timeArr;
    },
    getLabel(key, length, croute = false, allroute = false) {
      let current = croute;
      let all = allroute;

      if (!this.isChange) {
        current = false;
        all = false;
      }

      if ((current || current === 0) && all) {
        if (!key && !current) return this.$t('ticket.departure');
        if ((key + 1) === length && (current + 1) === all) return this.$t('ticket.arrived');
        if (key === 0 && current) return false;
        return null;
      }

      if (!key) {
        return this.$t('ticket.departure');
      } else if ((key + 1) === length) {
        return this.$t('ticket.arrived');
      }

      return null;
    },
  },
  computed: {
    isChange() {
      return Boolean(this.routes.length > 1);
    },
    iconBus() {
      return faBus;
    },
    iconArrow() {
      return faAngleDoubleRight;
    },
  },
};
</script>

<style lang='scss' scoped>
#app, #auth {
  .route {
    .station-bus {
      font-size: 1.7rem;
    }

    .station-arrow {
      vertical-align: .1rem;
    }

    .station-block {
      padding-bottom: 0;

      .station {
        margin-bottom: 0;
        margin-top: 0;
        font-size: 18px;
        font-weight: 500;

        &:before {
          content: "";
          width: 15px;
          height: 15px;
          border: 2px solid $color-main;
          display: inline-block;
          margin-right: 25px;
          vertical-align: text-bottom;
        }
      }

      .station-name {
        border-left: 1px dashed #d7d7d7;
        padding-bottom: 13px;
        margin-left: 7px;
        margin-top: 3px;
        margin-bottom: 0;
        padding-left: 35px;
        font-weight: 300;
        font-size: .9rem;

        &.last {
          border: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/Route.vue